import React from "react";
import withStyles from "components/common/wrappers/withStyles";

const More = ({ color = "white", svgClassname }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={svgClassname}
    >
      <path
        d="M8.00001 8.66667C8.36821 8.66667 8.66668 8.3682 8.66668 8C8.66668 7.6318 8.36821 7.33333 8.00001 7.33333C7.63181 7.33333 7.33334 7.6318 7.33334 8C7.33334 8.3682 7.63181 8.66667 8.00001 8.66667Z"
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6667 8.66667C13.0349 8.66667 13.3333 8.3682 13.3333 8C13.3333 7.6318 13.0349 7.33333 12.6667 7.33333C12.2985 7.33333 12 7.6318 12 8C12 8.3682 12.2985 8.66667 12.6667 8.66667Z"
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33332 8.66667C3.70151 8.66667 3.99999 8.3682 3.99999 8C3.99999 7.6318 3.70151 7.33333 3.33332 7.33333C2.96514 7.33333 2.66666 7.6318 2.66666 8C2.66666 8.3682 2.96514 8.66667 3.33332 8.66667Z"
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default withStyles(More);
